import style from "./style.module.scss";
import icon from "../../../img/modals/like.svg";
import {useStore} from "effector-react";
import {$store} from "../../../store";

const PlsBet = (props:{onOk:Function}) => {

	const store = useStore($store);

	return (
		<div className={style.plsBet}>
			<div className={style.icon}>
				<img src={icon} alt=""/>
			</div>
			<p className={style.title}>Спасибо!</p>
			<p className={style.subtitle}>Ваше участие в акции продолжится после того как вы сделаете любую ставку на спорт!</p>
			<p className={style.subtitleB}>Желаем Вам удачи!</p>
			<div className={style.buttons}>
				<div onClick={()=>{ props.onOk(); }} className={`${style.btn} ${style.btnA}`}>Понятно</div>
			</div>
		</div>
	);
};

export default PlsBet;
